// @ts-strict-ignore
import {Component, Injector} from "@angular/core";

import {BasicMaterialDialog, MatDialogDataBaseInput} from "../../basic-material-dialog/basic-material-dialog.directive";
import {
	Assessment,
	AssessmentState,
	CompetenceCategory,
	Participant,
	ParticipantDeviceAssessmentDisplayVariant,
	ParticipantState,
	ParticipantType,
	SimUser,
	UserRecordingAssessment,
} from "@models";
import {SimUtilityService} from "@services";
import {AssessablePanelMode} from "@common/components/assessment/utils";
import {FormControl} from "@angular/forms";

export interface DialogData_PreviewExamAssessmentDialogInput extends MatDialogDataBaseInput {
	assessment: Assessment;
	competenceCategories: CompetenceCategory[];
}

@Component({
	selector: "sim-station-preview-exam-assessment-dialog",
	templateUrl: "./preview-exam-assessment-dialog.component.html",
	styleUrl: "./preview-exam-assessment-dialog.component.scss",
	standalone: false,
})
export class PreviewExamAssessmentDialogComponent extends BasicMaterialDialog<
	PreviewExamAssessmentDialogComponent,
	DialogData_PreviewExamAssessmentDialogInput
> {
	protected readonly AssessmentState = AssessmentState;
	protected readonly AssessablePanelMode = AssessablePanelMode;
	protected readonly ParticipantDeviceAssessmentDisplayVariant = ParticipantDeviceAssessmentDisplayVariant;

	public readonly toggleControl = new FormControl<ParticipantDeviceAssessmentDisplayVariant>(
		ParticipantDeviceAssessmentDisplayVariant.Examiner,
	);
	public readonly previewAssessment: UserRecordingAssessment;
	public readonly previewParticipant: Participant;

	public constructor(injector: Injector) {
		super(injector);
		this.previewAssessment = this._generatePreviewAssessment(this.data.assessment, this.data.competenceCategories);
		this.previewParticipant = this._generatePreviewParticipant();
	}

	private _generatePreviewAssessment(assessment: Assessment, competenceCategories: CompetenceCategory[]): UserRecordingAssessment {
		return {
			...assessment,
			id: SimUtilityService.createGuid(),
			assessmentId: assessment.id,
			assessableId: assessment.id,
			state: AssessmentState.Passed,
			assignedCompetenceCategories: competenceCategories.filter((c) => assessment.competenceCategoryIds.includes(c.id)),
			note: "",
			reachedScore: 0,
			reachedScoreTemporary: 0,
			assessmentStateTemporary: AssessmentState.Passed,
			maxScore: 0,
			appraiseeIds: [],
			hasZeroScoreKnockoutQuestion: false,
			scenarioId: null,
			eventId: null,
			scenarioRecordingId: null,
			simSessionId: null,
		};
	}

	private _generatePreviewParticipant(): Participant {
		return {
			userId: SimUtilityService.createGuid(),
			state: ParticipantState.CheckedIn,
			participantType: ParticipantType.Learner,
			user: {
				firstname: "John",
				lastname: "Doe",
				fullname: "John Doe",
				id: SimUtilityService.createGuid(),
				isicNumber: "123456789",
				email: "john.doe@simstation.com",
			} as SimUser,
			authenticationCode: "1234",
		};
	}
}
